// Imports
import { Finances } from 'src/modules/finances-inner/jsx/finances.jsx';
import { Tiles } from 'src/modules/content-tiles/jsx/tiles.jsx';
import { AskUs } from 'src/modules/ask-us/jsx/component.jsx';
import { WantToLinks } from 'src/modules/i-want-to-links/jsx/component.jsx';
import { ServiceIndicator } from "src/modules/alerts/jsx/service-indicator.jsx";

// Stateless components

export function FinancesPage(props) {

    //
    // Render
    //

    return (
        <>
            <ServiceIndicator />
            <div className="page-inner__content">
                <Finances />
                <Tiles />
                <div className="page-inner__wrapper--two-col">
                    <AskUs />
                    <WantToLinks /> 
                </div>
            </div>
        </>
    );
};
